module.exports = " <span class=indicator-container _v-7511fb90=\"\"> <span class=indicator v-bind:class=indicatorClass _v-7511fb90=\"\"></span> <span v-if=showText class=\"indicator text\" _v-7511fb90=\"\">{{ indicatorText }}</span> </span> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-7511fb90!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Indicator.vue
// module id = 1160
// module chunks = 2